/* eslint-disable  @typescript-eslint/no-explicit-any */ // AJB: remove
import VERTICAL_OPTIONS from "@/constants/VerticalOptions";
import {
  FlatAspect,
  AreaSearch,
  RangeAspect,
} from "./HomePageSearchResponse";
import { AdSortOrderKey } from "@/actions/search/services/AdSortService";
import { FlatLocationAspect } from "@/constants/LocationHierarchy";

// AJB: still need these default?
class HomePageSearchRequest {
  // AJB: no longer just for home
  vertical: FlatAspect = VERTICAL_OPTIONS[0];
  categories: FlatAspect[] = [];
  breeds: FlatAspect[] = [];
  disciplines: FlatAspect[] = [];
  locations: FlatLocationAspect[] = [];
  colours: FlatAspect[] = [];
  genders: FlatAspect[] = [];
  riderLevels: FlatAspect[] = [];

  price: RangeAspect = new RangeAspect();
  age: RangeAspect = new RangeAspect();
  height: RangeAspect = new RangeAspect();

  searchQuery: string = "";

  area: AreaSearch = new AreaSearch();

  sortBy: AdSortOrderKey = "most-recent";
  page: number = 1;

  isShowreel?: boolean;
  isEmailFeatured?: boolean;
  isFeatured?: boolean;
  isUrgent?: boolean;
  hasVideo?: boolean;
  isHorse?: boolean;
  isCompact?: boolean;
  isSold?: boolean;

  createdAt?: RangeAspect = new RangeAspect();

  // AJB: tighten this up
  [key: string]: any;
}

export default HomePageSearchRequest;
